(function() {
    const openAccordion = (index) => {
        const accordion = document.getElementsByClassName("hcp-accordion-item");
      
        for (let i = 0; i < accordion.length; i++) {
          const content = accordion[i].querySelector(".hcp-accordion-content");
          const heading = accordion[i].querySelector(".hcp-accordion-heading");
      
          if (index === i) {
            const isOpen = accordion[index].classList.toggle("open");
            accordion[index].classList.toggle("rotate");
            heading.setAttribute("aria-expanded", isOpen);
            if (isOpen) {
              content.style.height = content.scrollHeight + "px";
            } else {
              content.style.height = "0px";
            }
          } else {
            accordion[i].classList.remove("open");
            accordion[i].classList.remove("rotate");
            heading.setAttribute("aria-expanded", "false");
            content.style.height = "0px";
          }
        }
      };
      
      document.querySelectorAll('.hcp-accordion-heading').forEach((heading, index) => {
        heading.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            openAccordion(index);
          }
        });
      });

      document.querySelectorAll('.hcp-accordion-heading').forEach((heading, index) => {
        heading.addEventListener('click', (event) => {
            openAccordion(index);
        });
      });
      
})();